import { graphql } from '@shared/api/gql';

export const collectionQueryDocument = graphql(`
	query GetCollection($id: ID!, $isSlug: Boolean!) {
		issue(id: $id, isSlug: $isSlug) {
			id
			name
			description
			cover
			slug
			releaseDate
			articles {
				id
				ArticleID
				thumbnail
				role
				name
				slug
				index
				description
				isFeatured
				created
				releaseDate
			}
		}
	}
`);
